import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import Header from 'Components/HeaderPlain';

const FloraQRBasedeventsAgeWise = () => {
    const [reportData, setReportData] = useState({});
    const [loading, setLoading] = useState(true);
    const [matchingCount, setMatchingCount] = useState(0);
    const [age3to8, setAge3to8] = useState(0);
const [age8to11, setAge8to11] = useState(0);
const [age11to14, setAge11to14] = useState(0);
const [age14to18, setAge14to18] = useState(0);
const [age18plus, setAge18plus] = useState(0);
const [totalCount, setTotalCount] = useState(0);
const [QRage3to8, QRsetAge3to8] = useState(0);
const [QRage8to11, QRsetAge8to11] = useState(0);
const [QRage11to14, QRsetAge11to14] = useState(0);
const [QRage14to18, QRsetAge14to18] = useState(0);
const [QRage18plus, QRsetAge18plus] = useState(0);
const [QRtotalCount, QRsetTotalCount] = useState(0);






    useEffect(() => {

        // const getCount = async (data) => {
        //     try {
        //         const response = await fetch('https://ecoclubs.education.gov.in/api/get-FloraQR-events-stateWise', {
        //             method: 'POST',
        //             headers: {
        //                 'Content-Type': 'application/json',
        //             },
        //             body: JSON.stringify(data),
        //         });

        //         const result = await response.json();

        //         if (result.status === 'success') {

        //             console.log('311111111111111',result)
        //             const counts = result.data.matchCount;

        //             setMatchingCount(counts.matchingCount);
        //             setUniqueDistrictCount(counts.uniqueDistrictCount);
        //             setUniqueStateCount(counts.uniqueStateCount);
        //         }
        //     } catch (error) {
        //         console.log(error);
        //     }
        // };

        const fetchReport = async () => {
            setLoading(true);
        
            try {
                const res = await fetch('https://ecoclubs.education.gov.in/api/get-FloraQR-events-AgeWise', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({}),
                });
        
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
        
                const data = await res.json();
                const filteredData = data.data.getFloraQrBasedEventCounts.all;
        
                console.log('Filtered Data:', filteredData);
        
                // Set each age group data to state
                setAge3to8(filteredData.age3to8);
                setAge8to11(filteredData.age8to11);
                setAge11to14(filteredData.age11to14);
                setAge14to18(filteredData.age14to18);
                setAge18plus(filteredData.age18plus);
        
                // Set the total participants count
                setTotalCount(filteredData.total_participants);



                const filteredDataQR = data.data.getFloraQrBasedEventCounts.filtered;
        
                console.log('Filtered Data:', filteredDataQR);
        
                // Set each age group data to state
                QRsetAge3to8(filteredDataQR.age3to8);
                QRsetAge8to11(filteredDataQR.age8to11);
                QRsetAge11to14(filteredDataQR.age11to14);
                QRsetAge14to18(filteredDataQR.age14to18);
                QRsetAge18plus(filteredDataQR.age18plus);
        
                // Set the total participants count
                QRsetTotalCount(filteredDataQR.total_participants);
        
            } catch (err) {
                console.error('Failed to fetch report data', err);
            } finally {
                setLoading(false);
            }
        };
        
        // getCount();
        fetchReport();
    }, []);

    return (
        <><Header />
        <div className="container mt-5" style={{ paddingBottom: '110px' }}>
            {/* <h3 className="text-center"><strong>Total Numbers of Schools Onboarded on Eco Clubs For Mission Life Portal</strong></h3> */}
            <h4 className="text-center text-primary" style={{ color: 'black', WebkitTextFillColor: 'black' }}>Total Participants For All The Events: <strong>{totalCount.toLocaleString("en-IN")}</strong></h4>
            <h4 className="text-center text-primary" style={{ color: 'black', WebkitTextFillColor: 'black' }}>Total Participants For Sub Theme Flora QR codes: <strong>{QRtotalCount.toLocaleString("en-IN")}</strong></h4>


            <div className="mt-5">
    <h4><strong>Age Wise Participants For All The Events</strong></h4>
    <table className="table table-bordered">
        <thead>
            <tr>
                <th>Age Category</th>
                <th className="text-center">Count</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 3 to 8</td>
                <td className="text-center">{age3to8.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 8 to 11</td>
                <td className="text-center">{age8to11.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 11 to 14</td>
                <td className="text-center">{age11to14.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 14 to 18</td>
                <td className="text-center">{age14to18.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 18+</td>
                <td className="text-center">{age18plus.toLocaleString("en-IN")}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td className="text-center"><strong>Total</strong></td>
                <td className="text-center">
                    <strong>{totalCount.toLocaleString("en-IN")}</strong>
                </td>
            </tr>
        </tfoot>
    </table>
</div>

<div className="mt-5">
    <h4><strong>Age Wise Participants For Sub Theme - Flora QR codes</strong></h4>
    <table className="table table-bordered">
        <thead>
            <tr>
                <th>Age Category</th>
                <th className="text-center">Count</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 3 to 8</td>
                <td className="text-center">{QRage3to8.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 8 to 11</td>
                <td className="text-center">{QRage8to11.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 11 to 14</td>
                <td className="text-center">{QRage11to14.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 14 to 18</td>
                <td className="text-center">{QRage14to18.toLocaleString("en-IN")}</td>
            </tr>
            <tr>
                <td style={{ textAlign: 'center' }}>Total Participants for 18+</td>
                <td className="text-center">{QRage18plus.toLocaleString("en-IN")}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td className="text-center"><strong>Total</strong></td>
                <td className="text-center">
                    <strong>{QRtotalCount.toLocaleString("en-IN")}</strong>
                </td>
            </tr>
        </tfoot>
    </table>
</div>







        </div>
        </>
    );
};

export default FloraQRBasedeventsAgeWise;
